import { Button, LinkButton, MuiAlert, ResponsiveDrawer, Spin, Typography } from '@fox/atoms';
import { FlexColumnSpaced, FlexRowSpaced } from '@fox/layout';
import { sendUpdate } from 'fox-extensions';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { useContentContext } from '../../../content-context';
import { REFETCH_GOALS } from '../../../topics';
import { useDeleteGoalActivity } from '../../mutation-hooks/mutation-implementations';

export function DeleteButtonDesktop({ id, activityLabel }: { id: string; activityLabel: string }) {
	const { contentId, requestToken } = useContentContext();
	const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
	const [needsRefetch, setNeedsRefetch] = useState<boolean>(false);
	const theme = useTheme();
	const { data, mutate, loading, error } = useDeleteGoalActivity({ requestToken });

	return (
		<>
			<LinkButton onClick={() => setDrawerOpen(true)} color={theme.palette.error.main}>
				Delete
			</LinkButton>
			<ResponsiveDrawer
				title={`Delete ${activityLabel.toLowerCase()}`}
				placement="right"
				width={500}
				open={drawerOpen}
				onClose={() => {
					setDrawerOpen(false);
					if (needsRefetch) {
						sendUpdate(REFETCH_GOALS);
					}
				}}
				destroyOnClose
			>
				{data === true ? (
					<MuiAlert severity="success">{`${activityLabel} sucessfully deleted`}</MuiAlert>
				) : (
					<>
						{error ? (
							<MuiAlert severity="error">{error}</MuiAlert>
						) : (
							<FlexColumnSpaced style={{ padding: '1rem' }}>
								<Typography>{`Are you sure you would like to remove this ${activityLabel.toLowerCase()}?`}</Typography>
								<Spin spinning={loading}>
									<FlexRowSpaced>
										<Button
											disabled={loading}
											variant="tertiary"
											onClick={() => {
												setDrawerOpen(false);
											}}
										>
											Cancel
										</Button>
										<Button
											disabled={loading}
											onClick={async () => {
												const res = await mutate({
													contentId,
													id
												});
												if (res === true) {
													setNeedsRefetch(true);
												}
											}}
											variant="primary"
										>
											Confirm
										</Button>
									</FlexRowSpaced>
								</Spin>
							</FlexColumnSpaced>
						)}
					</>
				)}
			</ResponsiveDrawer>
		</>
	);
}
export function DeleteButtonMobile({ id, activityLabel }: { id: string; activityLabel: string }) {
	const { contentId, requestToken } = useContentContext();
	const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
	const [needsRefetch, setNeedsRefetch] = useState<boolean>(false);
	const theme = useTheme();
	const { data, mutate, loading, error } = useDeleteGoalActivity({ requestToken, topics: [REFETCH_GOALS] });

	return (
		<>
			<LinkButton onClick={() => setDrawerOpen(true)} color={theme.palette.error.main}>
				Delete
			</LinkButton>

			<ResponsiveDrawer
				placement="bottom"
				title={`Delete ${activityLabel.toLowerCase()}`}
				width="100%"
				height="100%"
				style={{ height: '100%' }}
				open={drawerOpen}
				onClose={() => {
					setDrawerOpen(false);
					if (needsRefetch) {
						sendUpdate(REFETCH_GOALS);
					}
				}}
			>
				<FlexColumnSpaced style={{ padding: '1rem' }}>
					<Typography>{`Are you sure you would like to remove this ${activityLabel.toLowerCase()}?`}</Typography>
					<Spin spinning={loading}>
						<FlexRowSpaced>
							<Button
								disabled={loading}
								variant="tertiary"
								onClick={() => {
									setDrawerOpen(false);
								}}
							>
								Cancel
							</Button>
							<Button
								disabled={loading}
								onClick={async () => {
									const res = await mutate({
										contentId,
										id
									});
									if (res === true) {
										setNeedsRefetch(true);
									}
								}}
								variant="primary"
							>
								Confirm
							</Button>
						</FlexRowSpaced>
					</Spin>
					{error ? <MuiAlert severity="error">{error}</MuiAlert> : null}
				</FlexColumnSpaced>
			</ResponsiveDrawer>
		</>
	);
}
